const DEFAULT_ACCENT_HEX = "#95c11f";

export function buildHandoverEmailSubject(propertyLabel) {
   return `Übergabeprotokoll – ${propertyLabel}`;
}

/**
 * Kurze HTML-Mail, die auf das im Anhang mitgeschickte Übergabeprotokoll-PDF verweist.
 * Tabellenbasiertes Layout für verlässliche Darstellung in gängigen Mail-Clients (u. a. Outlook).
 */
export function buildHandoverEmailHtml({ propertyLabel, filename, accentColor = DEFAULT_ACCENT_HEX, senderName = "Baur Immobilien GmbH" }) {
   return `
<table role="presentation" width="100%" cellpadding="0" cellspacing="0" style="background:#f4f4f5; padding:24px 0; font-family: Arial, Helvetica, sans-serif;">
  <tr>
    <td align="center">
      <table role="presentation" width="100%" style="max-width:520px; background:#ffffff; border-radius:8px; border:1px solid #e5e5e5;" cellpadding="0" cellspacing="0">
        <tr>
          <td style="height:4px; background:${accentColor}; line-height:4px; font-size:0; border-radius:8px 8px 0 0;">&nbsp;</td>
        </tr>
        <tr>
          <td style="padding:28px 32px 8px 32px;">
            <h1 style="margin:0 0 4px; font-size:18px; color:#1f1f1f;">Übergabeprotokoll</h1>
            <div style="font-size:13px; color:#6b6b6b;">${propertyLabel}</div>
          </td>
        </tr>
        <tr>
          <td style="padding:8px 32px 4px 32px; font-size:14px; line-height:1.55; color:#333333;">
            <p style="margin:0 0 14px;">Guten Tag,</p>
            <p style="margin:0 0 14px;">
              im Anhang finden Sie das <strong>Übergabeprotokoll</strong> zur Immobilie ${propertyLabel} als PDF.
              Es enthält die Objektdaten, Zählerstände, die Schlüsselübergabe sowie die Unterschriften aller Beteiligten.
            </p>
            <p style="margin:0;">Bei Rückfragen stehen wir Ihnen gerne zur Verfügung.</p>
          </td>
        </tr>
        <tr>
          <td style="padding:16px 32px 24px 32px; border-top:1px solid #f0f0f0; font-size:12px; color:#999999;">
            Mit freundlichen Grüßen<br /><br />${senderName}
          </td>
        </tr>
      </table>
    </td>
  </tr>
</table>`.trim();
}
